import { useState, useEffect } from "react";
import { setDefaultLocale } from "react-datepicker";
import API from "../../services/api";

export default function useFindUser() {
  const [user, setUser] = useState(null);
  const [roles, setRoles] = useState([]);
  const [positions, setPositions] = useState([]);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    async function findUserOnMount() {
      setLoading(true);
      const uuid = localStorage.getItem("uuid");
      if (!uuid) {
        setUser(null);
        setLoading(false);
        return;
      }

      try {
        const response = await API.get(`/auth/users/${uuid}`);
        if (response?.data) {
          setUser(response.data);
          setDefaultLocale(localStorage.getItem("i18nextLng"));
        } else {
          setUser(null);
        }
      } catch (err) {
        console.error("Failed to fetch user in useFindUser useEffect:", err);
        setUser(null);
      } finally {
        setLoading(false);
      }
    }

    findUserOnMount();
  }, []);

  async function getUser() {
    console.warn(
      "useFindUser's getUser function was called. Its direct state modification is disabled pending review."
    );
  }

  return {
    user,
    setUser,
    getUser,
    roles,
    setRoles,
    positions,
    setPositions,
    isLoading,
  };
}
